<template>
  <div>
    <slot :trigger-support="triggerSupport" />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'

import { useIntercomStore } from './useIntercomStore'

const intercomStore = useIntercomStore()

const triggerSupport = () => {
  intercomStore.showIntercom()
}

onMounted(async () => {
  await intercomStore.initializeIntercom()
})
</script>
